import { branding } from '@/config/branding'
import { useCurrentOrganizationIdFromState } from '@/stores/authStore'
import { useEffect } from 'react'
import { useOrgBrandMark } from './useOrgBrandMark'

/**
 * Sets the browser favicon from the current org's brand_mark.
 * Falls back to the configured platform favicon when no brand_mark is set.
 */
export function useDynamicFavicon() {
	const brandMark = useOrgBrandMark(useCurrentOrganizationIdFromState())

	useEffect(() => {
		const link: HTMLLinkElement = document.querySelector("link[rel~='icon']") || document.createElement('link')
		link.rel = 'icon'
		link.href = brandMark || branding.images.favicon

		if (!document.head.contains(link)) {
			document.head.appendChild(link)
		}
	}, [brandMark])
}
